import { render } from "./MediaView.vue?vue&type=template&id=2b3cb639"
import script from "./MediaView.vue?vue&type=script&lang=js"
export * from "./MediaView.vue?vue&type=script&lang=js"

import "./MediaView.vue?vue&type=style&index=0&id=2b3cb639&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__